<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Types</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="group"
            direction="ASC"
            delete-label="name"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Types",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'types',
                numberOfFilters: 2,
                pageActions: {},
                fields: [
                    {
                        name: 'Group',
                        column: 'group_name',
                        sortCol: 'group'
                    },
                    {
                        name: 'Option',
                        column: 'name',
                        sortCol: 'name',
                    },
                    {
                        name: 'Colour',
                        column: 'colour',
                        colour: true
                    },
                    {
                        name: 'Ordering',
                        column: 'ordering',
                        sortCol: false,
                        align: 'center',
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        sortCol: false,
                        boolean: true,
                        align: 'center',
                        toggle: true,
                    },
                    {
                        name: 'Locked',
                        column: 'locked',
                        sortCol: false,
                        boolean: true,
                        align: 'center',
                        toggle: false,
                    },
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'types.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'types.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Groups Filter
            const groupsFilter = {
                label: 'Group',
                name: 'group',
                type: 'select',
                options: this.$store.getters.typeGroups.map(function (group) {
                    return {label: group.group_name, value: group.group};
                }),
                width: 'w-1/4',
                value: this.groupValue,
                placeholder: 'Select Group...'
            };

            if (this.$store.getters.typeGroups.length === 0){
                this.$store.dispatch('GET_TYPE_GROUPS').then(() => {
                    groupsFilter.options = this.$store.getters.typeGroups.map(function (group) {
                        return { label: group.group_name, value: group.group };
                    });
                    groupsFilter.value = this.groupValue;
                    this.filters.push(groupsFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(groupsFilter);
            }

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Option',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/types/option/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('types.create') !== -1
                    },
                    {
                        label: 'New Group',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/types/group/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('types.create') !== -1
                    },
                    {
                        label: 'Re-Order',
                        icon: 'sort',
                        type: 'router-link',
                        link: '/configuration/types/order',
                        iconClass: 'text-gray-800',
                        display: this.$store.getters.permissions.indexOf('types.create') !== -1
                    }
                ],
                additional: []
            }
        },
        watch: {
            filters: function(){
                if (this.filters.length === this.numberOfFilters){
                    this.filtersLoading = false;
                }
            }
        },
    }
</script>

<style scoped>

</style>
